import { useCallback, useState } from 'react'
import {
  ReferenceInput,
  AutocompleteInput,
  SearchInput,
  FilterForm,
  IconButtonWithTooltip,
} from 'react-admin'
import { Stack, Checkbox, FormControlLabel } from '@mui/material'

import PaieEventDialog from './PaieEventDialog'

import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'

const DashboardToolbar = ({ isMobile = false, isAdmin = false, withPaie = false, setWithPaie }) => {
  const [openPaieEvent, setOpenPaieEvent] = useState(false)

  // Update filters when checkbox changes
  const handleWithPaieChange = useCallback((event) => {
    setWithPaie(event.target.checked)
  }, [setWithPaie])

  // Default Filters
  const DashboardFilter = [
    <SearchInput
      key="last_name"
      placeholder="Nom"
      source="last_name@ilike"
      variant="outlined"
      sx={{ maxWidth: '200px' }}
      alwaysOn
      resettable
    />,

    <SearchInput
      key="first_name"
      placeholder="Prénom"
      source="first_name@ilike"
      variant="outlined"
      sx={{ maxWidth: '200px' }}
      alwaysOn
      resettable
    />,
  ]

  if (isAdmin) {
    DashboardFilter.push(
      <ReferenceInput
        key="center"
        reference="centers"
        source="center_id"
        alwaysOn
      >
        <AutocompleteInput
          label="Centre"
          variant="outlined"
          optionText="name"
          filterToQuery={searchText => ({ 'name@ilike': searchText })}
        />
      </ReferenceInput>
    )
  }

  return (
    <>
      <PaieEventDialog
        open={openPaieEvent}
        setOpen={setOpenPaieEvent}
      />

      <Stack direction={isMobile ? 'column' : 'row'} style={{ padding: '0 10px' }}>
        <FilterForm filters={DashboardFilter} />

        <FormControlLabel
          control={
            <Checkbox
              checked={withPaie ? true : false}
              onChange={handleWithPaieChange}
            />
          }
          label="Pubeurs avec paie uniquement"
          sx={{ marginLeft: 2 }}
        />

        <IconButtonWithTooltip
          label="Ajouter un évènement de paie"
          onClick={() => setOpenPaieEvent(true)}
          color="primary"
        >
          <AddCircleOutlineIcon />
        </IconButtonWithTooltip>
      </Stack>
    </>
  )
}

export default DashboardToolbar
